module.exports = __webpack_public_path__ + "img/logo1.dda50744.svg";